import {  createWebHashHistory,createRouter } from "vue-router";

import NotFound from '@/pages/404';

// Route Pages for Production
// Uncomment Below Routes for production pages
import DashV3 from '@/pages/dash-v3';
import DTDash from '@/pages/dt-dash';
import ExecutiveDash from '@/pages/executive-dash';
import ProjectAR from '@/pages/project-ar';
import ProjectList from '@/pages/project-list';
import Sectors from '@/pages/sectors';
import SectorDetail from '@/pages/sector-detail';
import Dashboards from '@/pages/dashboards'
import ExecutiveSummary from '@/pages/executive-summary'
import TransformationProjects from '@/pages/transformation-projects'

// Route Pages for Dev
// Uncomment Below Routes for development pages
// import DashV3 from '@/pages/dev/dash-v3';
// import DTDash from '@/pages/dev/dt-dash';
// import ExecutiveDash from '@/pages/dev/executive-dash';
// import ProjectAR from '@/pages/dev/project-ar';
// import ProjectList from '@/pages/dev/project-list';
// import Sectors from '@/pages/dev/sectors';
// import SectorDetail from '@/pages/dev/sector-detail';



const routes = [
    // Production Routes
    {
      path: "/",
      name: "dashboards",
      component: Dashboards,
      meta: { title: 'SDB - Dashboards' }
    },
    {
      path: "/dashv3",
      name: "dashv3",
      component: DashV3,
      meta: { title: 'SDB - Dashbord' }
  
    },
    {
      path: "/executive-summary",
      name: "executivesummary",
      component: ExecutiveSummary,
      meta: { title: 'SDB - Executive summary' }
  
    },
    {
      path: "/transformation-projects",
      name: "transformationprojects",
      component: TransformationProjects,
      meta: { title: 'SDB - Transformation Projects' }
  
    },
    {
      path: "/dt",
      name: "dashdt",
      component: DTDash,
      meta: { title: 'SDB - Dashbord' }
  
    },
    {
      path: "/executive",
      name: "dashexecutive",
      component: ExecutiveDash,
      meta: { title: 'SDB - Dashbord' }
  
    },
    {
      path: "/project-ar",
      name: "projectar",
      component: ProjectAR,
      meta: { title: 'SDB - Project AR' }
  
    },
    {
      path: "/project-list",
      name: "projectlist",
      component: ProjectList,
      meta: { title: 'SDB - Project List' }
  
    },
    {
      path: "/sectors",
      name: "sectors",
      component: Sectors,
      meta: { title: 'SDB - Sectors' }
    },
    {
      path: "/sector-detail",
      name: "sectordetail",
      component: SectorDetail,
      meta: { title: 'SDB - Sector Detail' }
    },
    
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: NotFound,
    },

    // // Dev Routes
    // {
    //   path: "/dev",
    //   name: "dashv3dev",
    //   component: DashV3Dev,
    //   meta: { title: 'SDB - Dev Dashbord' }
  
    // },
    // {
    //   path: "/dev/dt",
    //   name: "dashdtdev",
    //   component: DTDashDev,
    //   meta: { title: 'SDB - Dev Dashbord' }
  
    // },
    // {
    //   path: "/dev/executive",
    //   name: "dashexecutivedev",
    //   component: ExecutiveDashDev,
    //   meta: { title: 'SDB - Dev Dashbord' }
  
    // },
    // {
    //   path: "/dev/project-ar",
    //   name: "projectardev",
    //   component: ProjectARDev,
    //   meta: { title: 'SDB - Dev Project AR' }
  
    // },
    // {
    //   path: "/dev/project-list",
    //   name: "projectlistdev",
    //   component: ProjectListDev,
    //   meta: { title: 'SDB - Dev Project List' }
  
    // },
    // {
    //   path: "/dev/sectors",
    //   name: "sectorsdev",
    //   component: SectorsDev,
    //   meta: { title: 'SDB - Dev Sectors' }
    // },
    // {
    //   path: "/dev/sector-detail",
    //   name: "sectordetaildev",
    //   component: SectorDetailDev,
    //   meta: { title: 'SDB - Dev Sector Detail' }
    // },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
  });
  

export default router;